// Others
import { IBaseOption } from '~/utils/interface/common';

export const mockDataEmployeeRole: IBaseOption[] = [
  {
    label: 'Admin',
    value: '00001',
  },
  {
    label: 'Staff',
    value: '00002',
  },
  {
    label: 'Technician',
    value: '00003',
  },
];

export const mockDataEmployeeStatus: IBaseOption[] = [
  {
    label: 'All',
    value: 'ALL',
  },
  {
    label: 'Active',
    value: 'ACTIVE',
  },
  {
    label: 'Inactive',
    value: 'INACTIVE',
  },
];
